import React, { Component } from "react";

import { Row, Col } from "react-flexbox-grid";
import Paper from "material-ui/Paper";
import Divider from "material-ui/Divider";
import Typography from "material-ui-next/Typography";
import Subheader from "material-ui/Subheader";
import Moment from "moment";
import {
  Page,
  StyledButton,
  IconButton,
  Loadable,
  CheckBox,
  TextField,
  SelectField,
  CurrencyField
} from "components/support";

import { DiscountTypeOptions } from "core/enum";
import Big from "big.js";

class DiscountFormView extends Component {
  getLabel = () => {
    const { type } = this.props.viewModel.form;

    const label = {
      variable_percentual: "Percentual de Desconto Limite",
      fixed_percentage: "Percentual de Desconto Fixo",
      fixed_value: "Percentual"
    };

    return label[type] || "Percentual";
  };

  handleChangeCurrency = (field, currency) => {
    const { presenter } = this.props;
    let value;
    if (field === "minimum_value") {
      value = parseInt(
        Big(currency)
          .times(100)
          .toString(),
        10
      );
    } else if (field === "percentual_value") {
      value =
        parseInt(currency, 10) > 100
          ? 0
          : parseInt(
              Big(currency)
                .times(100)
                .toString(),
              10
            );
    } else if (field === "discount_value" && currency.length < 9) {
      value = parseInt(
        Big(currency)
          .times(100)
          .toString(),
        10
      );
    }
    presenter.onChange(field, value);
  };

  handleDateValue = date => {
    if (!date) return;

    const dateFormat = /^([0-9,_]{2})(\/)([0-9,_]{2})(\/)([0-9,_]{4})$/i;

    return dateFormat.test(date)
      ? date
      : Moment(new Date(date))
          .utc()
          .format("DD/MM/YYYY");
  };

  render() {
    const { presenter, viewModel } = this.props;
    const { title, errors, loading, form } = viewModel;

    form.start_date = this.handleDateValue(form.start_date);
    form.end_date = this.handleDateValue(form.end_date);

    return (
      <Page>
        <Col xs={12}>
          <Typography type="display1" className="pb-sm">
            <IconButton
              icon="arrow_back"
              onClick={() => presenter.onGoBack()}
            />
            {title}
          </Typography>
          <Loadable loading={loading}>
            <Paper elevation={1}>
              <div className="grid-container">
                <Subheader>
                  Os campos marcados com * são obrigatórios.
                </Subheader>
                <Divider />
                <Row>
                  <Col xs={12}>
                    <TextField
                      fullWidth
                      underlineShow={false}
                      value={form.description}
                      floatingLabelFixed
                      floatingLabelText="Descrição*"
                      onChange={(_, value) =>
                        presenter.onChange("description", value)
                      }
                      errorText={errors.description}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col xs={12} md={4}>
                    <SelectField
                      fullWidth
                      label="Tipo de Desconto*"
                      options={DiscountTypeOptions}
                      value={form.type}
                      onChange={(_, value) => presenter.onChange("type", value)}
                      errorText={errors.type}
                    />
                  </Col>
                  <Col xs={12} md={4}>
                    <CurrencyField
                      fullWidth
                      unit=""
                      suffix="%"
                      value={Big(form.percentual_value || 0)
                        .div(100)
                        .toString()}
                      label={this.getLabel()}
                      onChange={(_, value) =>
                        this.handleChangeCurrency("percentual_value", value)
                      }
                      errorText={errors.percentual_value}
                      disabled={
                        ["fixed_percentage", "variable_percentual"].includes(
                          form.type
                        )
                          ? false
                          : true
                      }
                    />
                  </Col>
                  <Col xs={12} md={4}>
                    <CurrencyField
                      allowNegative={false}
                      fullWidth
                      value={Big(form.discount_value || 0)
                        .div(100)
                        .toString()}
                      label={`Valor de desconto ${
                        form.type === "variable_value" ? "Limite" : ""
                      }`}
                      unit="R$ "
                      onChange={(_, value) =>
                        this.handleChangeCurrency("discount_value", value)
                      }
                      errorText={errors.discount_value}
                      disabled={
                        ["fixed_value", "variable_value"].includes(form.type)
                          ? false
                          : true
                      }
                    />
                  </Col>
                </Row>

                <Row>
                  <Col xs={12} md={4}>
                    <CurrencyField
                      allowNegative={false}
                      fullWidth
                      value={Big(form.minimum_value || 0)
                        .div(100)
                        .toFixed(2)
                        .toString()}
                      label="Valor Mínimo da Venda"
                      unit="R$ "
                      onChange={(_, value) =>
                        this.handleChangeCurrency("minimum_value", value)
                      }
                      errorText={errors.minimum_value}
                    />
                  </Col>
                  <Col xs={12} md={4}>
                    <TextField
                      maskPattern={[
                        /\d/,
                        /\d/,
                        "/",
                        /\d/,
                        /\d/,
                        "/",
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/
                      ]}
                      fullWidth
                      underlineShow={false}
                      value={form.start_date}
                      floatingLabelFixed
                      floatingLabelText="Vigência Inicial*"
                      onChange={(_, value) =>
                        presenter.onChange("start_date", value)
                      }
                      errorText={errors.start_date}
                      disabled={form.created_at ? true : false}
                    />
                  </Col>
                  <Col xs={12} md={4}>
                    <TextField
                      maskPattern={[
                        /\d/,
                        /\d/,
                        "/",
                        /\d/,
                        /\d/,
                        "/",
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/
                      ]}
                      fullWidth
                      underlineShow={false}
                      value={form.end_date}
                      floatingLabelFixed
                      floatingLabelText="Vigência Final"
                      onChange={(_, value) =>
                        presenter.onChange("end_date", value)
                      }
                      errorText={errors.end_date}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col xs={12}>
                    <TextField
                      rows={5}
                      fullWidth
                      multiLine
                      value={form.rule_text}
                      floatingLabelFixed
                      floatingLabelText="Regra*"
                      onChange={(_, value) =>
                        presenter.onChange("rule_text", value)
                      }
                      errorText={errors.rule_text}
                      multilineMaxLength={250}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col xs={12}>
                    <CheckBox
                      checked={form.cpf_required}
                      label="CPF do cliente é obrigatório na venda"
                      onCheck={checked =>
                        presenter.onChange("cpf_required", checked)
                      }
                      toForm
                    />
                  </Col>
                </Row>

                <Divider className="mt-sm" />

                <div className="text-right p-sm">
                  <StyledButton
                    label="Cancelar"
                    onClick={() => presenter.onGoBack()}
                    flat
                  />
                  <StyledButton
                    label="Salvar Desconto"
                    primary
                    onTouchTap={() => presenter.onSendForm()}
                  />
                </div>
              </div>
            </Paper>
          </Loadable>
        </Col>
      </Page>
    );
  }
}

export default DiscountFormView;



// WEBPACK FOOTER //
// ./src/components/app/registration/discount/form/view.jsx